import React from "react";
import Logo from "../../../assets/images/logo-colored.png";
import "./Loader.scss";

/**
 * Loader Component
 * A modern and clean loading spinner using the company logo.
 *
 * @param {boolean} isLoading - Controls the visibility of the loader
 * @param {string} message - The text to display below the loader
 * @returns {JSX.Element|null} Returns the loader component or null
 */
const Loader = ({ isLoading, message = "Loading..." }) => {
  // Early return if not loading to prevent unnecessary rendering
  if (!isLoading) return null;

  return (
    <div className="loader-overlay">
      <div className="loader-content">
        <div className="logo-loader">
          <img src={Logo} alt="Loading..." className="loader-logo" />
        </div>
      </div>
    </div>
  );
};

export default Loader;
